import styled, { css } from "styled-components";

export const otherDetailInputPaddingMixin = (({ theme }) => css`
  padding-left: 22px;
  padding-right: 22px;

  @media only screen and (min-width: ${theme.breakpoints.M}) {
    padding-left: 37px;
    padding-right: 37px;
  }
`);

export const OtherDetailInputPadding = styled.div`
  ${otherDetailInputPaddingMixin}
`;